import {api} from './../../../system/api';

export default {
    completePackingBag: (params) => api.put('bags/' + params.id + '/packing-complete', {...params}, {singleRequest: true}),
};